import * as React from 'react';
import notify from '../../shared/feedback/notifications';
import {
    Button,
    Row,
    Col,
    Table,
    DropdownButton,
    MenuItem,
    FormGroup,
    ControlLabel
} from 'react-bootstrap';
import DateTime from 'react-datetime';
import moment from 'moment';
import { connect } from 'react-redux';
import FormSelect from '../../components/common/FormSelect';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import * as Features from '../../shared/Features';
import * as Site from '../../shared/Site';

import AutoUpdateListTrigger from '../../shared/AutoUpdateListTrigger';
import ProductPropertiesIcons from '../propertyIcons/ProductPropertiesIcons';
import OrderStatusesIcons from '../statusicons/StatusIcons';
import DateTimeView from '../localDate/DateTimeView';
import OrderListTableCell from '../../components/common/OrderListTableCell';
import * as Actions from './actions/PhotoOrderListActions';
import * as DownloadActions from '../../actions/DownloadActions';
import PhotoListApi from './PhotoListApi';
import { DownloadButtonWithDropDown } from './DownloadButtonWithDropDown';
import ProgressBarOverlay from '../../components/common/ProgressOverlay';
import Loader from 'react-loader';
import FormInputChangeHandler from './../../shared/form/FormInputChangeHandler';
import * as EditorsCustomPhotoStatus from './../../shared/EditorsCustomPhotoStatus';
import { getUser } from '../../reducers/userReducer';

interface IUneditedPhotoOrdersListActions {
    getUneditedPhotoOrders: (date: any) => any;
    assignOrder: (
        orderId: number,
        userId: number,
        imageEditorName: string,
        assignedToCurrentUser: boolean
    ) => any;
    unAssignOrder: (orderId: number) => any;
    downloadFile: (url: string) => any;
}

interface IUneditedPhotoOrdersListProps {
    user: any;
    actions: IUneditedPhotoOrdersListActions;
    orders: any[];
    photoStatuses: any[];
    download: any;
}

class UneditedPhotoOrdersList extends React.Component<IUneditedPhotoOrdersListProps, any> {
    private _updateListTrigger: AutoUpdateListTrigger;
    private readonly Express: number = 11;
    private readonly EarlyDelivery: number = 8;
    private readonly ExpressWeekend: number = 12;
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: IUneditedPhotoOrdersListProps, context: any) {
        super(props, context);
        this.state = {
            orders: [],
            imageEditors: [],
            photoStatuses: [],
            downloading: false,
            isLoading: false,
            filters: {
                product: -1,
                orderStatus: -1,
                endDate: moment(new Date()),
                isLoading: false
            },
            forcedStatus: false
        };
        this.getUneditedPhotoOrders = this.getUneditedPhotoOrders.bind(this);
        this.getImageEditors = this.getImageEditors.bind(this);
        this.assignOrder = this.assignOrder.bind(this);
        this.unAssignOrder = this.unAssignOrder.bind(this);
        this._updateListTrigger = new AutoUpdateListTrigger(this.getUneditedPhotoOrders);
        this.downloadEditedImages = this.downloadEditedImages.bind(this);
        this.setValue = this.setValue.bind(this);
        this.onDateTimeChange = this.onDateTimeChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IUneditedPhotoOrdersListProps, nextState: any) {
        this.setState({
            orders: assign([], nextProps.orders)
        });
    }

    UNSAFE_componentWillMount() {
        this.formInputChangeHandler = new FormInputChangeHandler(this.state.filters, this.setValue);
        this.setState({ orders: [] });
        this.getImageEditors();
        this.getUneditedPhotoOrders();
        this._updateListTrigger.subscribe();
    }

    componentWillUnmount() {
        this._updateListTrigger.unsubscribe();
    }

    setValue(newState: any) {
        this.setState({ filters: newState });
    }

    getImageEditors() {
        if (!Features.hasFeature(Features.AdministrateImageEditors, this.props.user)) {
            return;
        }
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            PhotoListApi.getImageEditors()
                .then((x: any) => {
                    this.setState({ isLoading: false, imageEditors: x });
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false });
                });
        }
    }

    getUneditedPhotoOrders() {
        let date = moment(this.state.filters.endDate);

        if (!this.state.isLoading) {
            this.setState({ isLoading: true, orders: [] });
            this.props.actions
                .getUneditedPhotoOrders(date.toDate())
                .then((x: any) => {
                    this.setState({ isLoading: false });
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false });
                    notify.failure(Translate('unedited-orders/toastr/error'));
                });
        }
    }

    onDateTimeChange(moment: any): void {
        let filters = this.state.filters;
        filters.endDate = moment;
        filters.orderStatus = -1;

        this.setState(
            {
                filters: assign({}, filters),
                forcedStatus: false
            },
            () => this.getUneditedPhotoOrders()
        );
    }

    downloadEditedImages(orderId: number, forcePrimaryStorage?: boolean) {
        let { apiUrl } = window.appConfig;

        this.props.actions.downloadFile(
            `${apiUrl}/views/orders/${orderId}/imageprocessing/download?isEdited=0&isNormalResolution=0&forcePrimaryStorage=${
                forcePrimaryStorage ? '1' : '0'
            }`
        );
    }

    getImageEditorsName(userId: number): string {
        if (this.props.user.details.id === userId) {
            return this.props.user.details.name;
        } else {
            return this.state.imageEditors.filter((x: any) => x.id === userId)[0].name;
        }
    }

    assignOrder(orderId: number, userId: number) {
        const imageEditorName = this.getImageEditorsName(Number(userId));
        this.props.actions
            .assignOrder(
                orderId,
                userId,
                imageEditorName,
                Number(userId) === this.props.user.details.id
            )
            .catch((error) => {
                notify.failure(Translate('unedited-orders/toastr/error'));
            });
    }

    unAssignOrder(orderId: number) {
        this.props.actions.unAssignOrder(orderId).catch((error) => {
            notify.failure(Translate('unedited-orders/toastr/error'));
        });
    }

    redirectToOrder(orderId: number) {
        (this.props as any).router.push({
            pathname: `/orders/${orderId}/image`
        });
    }

    renderAssignColumn(order: any, orderLink: string) {
        if (
            order.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Unknown ||
            order.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Future
        ) {
            return <td>{order.imageEditorName}</td>;
        }

        if (order.assignedToCurrentUser) {
            return (
                <td>
                    <Button
                        onClick={() => {
                            this.unAssignOrder(order.orderId);
                        }}
                    >
                        {Translate('unedited-orders/table/button/unassign-order')}
                    </Button>
                </td>
            );
        }

        if (
            order.isAssigned &&
            Features.hasFeature(Features.AdministrateImageEditors, this.props.user)
        ) {
            return (
                <td>
                    <DropdownButton id="image-editor-switch" title={order.imageEditorName}>
                        <MenuItem
                            eventKey="1"
                            onClick={() => {
                                this.unAssignOrder(order.orderId);
                            }}
                        >
                            {Translate('unedited-orders/table/button/unassign-order')}
                        </MenuItem>
                    </DropdownButton>
                </td>
            );
        }

        if (
            order.isAssigned &&
            !Features.hasFeature(Features.AdministrateImageEditors, this.props.user)
        ) {
            return (
                <OrderListTableCell clickable={order.isAssigned} navigateTo={orderLink}>
                    {order.imageEditorName}
                </OrderListTableCell>
            );
        }

        if (
            !order.isAssigned &&
            (!this.state.imageEditors || this.state.imageEditors.length === 0)
        ) {
            return (
                <td>
                    <Button
                        onClick={() => {
                            this.assignOrder(order.orderId, this.props.user.details.id);
                        }}
                    >
                        {Translate('unedited-orders/table/button/assign-order')}
                    </Button>
                </td>
            );
        }

        if (!order.isAssigned && this.state.imageEditors && this.state.imageEditors.length > 0) {
            return (
                <td>
                    <FormSelect
                        name="imageEditor"
                        value={order.userId ? order.userId.toString() : '-1'}
                        onChange={(x: any) => this.assignOrder(order.orderId, x.target.value)}
                    >
                        <option value={'-1'}>
                            {Translate('view-order/basic-order-info/titles/image-editor/default')}
                        </option>
                        {this.state.imageEditors.map((x: any, index: number) => (
                            <option key={x.id} value={x.id.toString()}>
                                {x.name}
                            </option>
                        ))}
                    </FormSelect>
                </td>
            );
        }

        return <td></td>;
    }

    createTable(orders: any[]) {
        const buttonStyle = {
            width: 'max-content'
        };
        const buttonDivLeftStyle = {
            float: 'left'
        };
        const buttonDivRightStyle = {
            position: 'relative',
            float: 'right',
            borderLeft: 'medium groove Gainsboro',
            marginLeft: '10px'
        };

        return (
            <Table className="order-table table-nopadding unedited-orders-table" responsive hover>
                <thead>
                    <tr>
                        <th width="125">{Translate('unedited-orders/table/header/orderid')}</th>
                        <th width="60">{Translate('unedited-orders/table/header/quantity')}</th>
                        <th>{Translate('unedited-orders/table/header/ordered')}</th>
                        <th>{Translate('unedited-orders/table/header/photographer-name')}</th>
                        <th>{Translate('unedited-orders/table/header/edit-style-name')}</th>
                        <th>
                            {Translate('unedited-orders/table/header/image-editing-information')}
                        </th>
                        <th>{Translate('unedited-orders/table/header/size')}</th>
                        <th width="140">{Translate('unedited-orders/table/header/deadline')}</th>
                        <th>{Translate('unedited-orders/table/header/image-editor')}</th>
                        <th width="95"></th>
                        <th width="50"></th>
                        <th width="95"></th>
                    </tr>
                </thead>
                <tbody>
                    {orders
                        .sort((a, b) => {
                            if (!a.deadline && !b.deadline) {
                                return 0;
                            } else if (!b.deadline && a.deadline) {
                                return -1;
                            } else if (!a.deadline && b.deadline) {
                                return 1;
                            } else
                                return (
                                    new Date(a.deadline.localDateTime) -
                                    new Date(b.deadline.localDateTime)
                                );
                        })
                        .map((order, index) => {
                            const orderLink = `/orders/${order.orderId}/image`;

                            let rowClass = Site.getOrderCssClass(order.site);
                            if (order.isExpress) {
                                rowClass += ' express';
                            } else if (order.isExpressWeekend) {
                                rowClass += ' express-weekend';
                            } else if (order.isEarlyDelivery) {
                                rowClass += ' early-delivery';
                            }

                            return (
                                <tr key={order.orderId} className={rowClass}>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.orderCollectionNumber + ':' + order.orderNumber}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.quantity}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.productName}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.photographerName}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.editStyleName}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {order.imageEditingInformation}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        {Translate('unedited-orders/table/header/high-size')}:{' '}
                                        {order.highSize}px, {order.highDpi}dpi
                                        <br />
                                        {order.normalSize &&
                                            Translate('unedited-orders/table/header/normal-size') +
                                                ': ' +
                                                order.normalSize +
                                                'px, ' +
                                                order.normalDpi +
                                                'dpi'}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        <DateTimeView dateTime={order.deadline} />
                                    </OrderListTableCell>
                                    {this.renderAssignColumn(order, orderLink)}
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        <ProductPropertiesIcons
                                            properties={order.productProperties}
                                        ></ProductPropertiesIcons>
                                        {order.photoCommentCount > 0 && (
                                            <span className="property-icons">
                                                <i
                                                    title={
                                                        order.photoCommentCount +
                                                        ' photo(s) rejected'
                                                    }
                                                    className="material-icons replay"
                                                >
                                                    call_missed
                                                </i>
                                            </span>
                                        )}
                                    </OrderListTableCell>
                                    <OrderListTableCell
                                        clickable={order.isAssigned}
                                        navigateTo={orderLink}
                                    >
                                        <OrderStatusesIcons
                                            orderStatuses={order.orderStatuses}
                                        ></OrderStatusesIcons>
                                    </OrderListTableCell>
                                    <td>
                                        {order.isAssigned && (
                                            <DownloadButtonWithDropDown
                                                secondaryStorageExists={
                                                    order.secondaryStorageExists
                                                }
                                                downloadEditedImages={this.downloadEditedImages}
                                                order={order}
                                            />
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </Table>
        );
    }

    render() {
        let filters = this.state.filters;
        let orders = this.state.orders;

        const selectedDate = moment(filters.endDate).toDate().toISOString().slice(0, 10);
        const today = moment(new Date()).toDate().toISOString().slice(0, 10);

        if (
            this.state.forcedStatus === false &&
            filters.orderStatus === -1 &&
            selectedDate < today
        ) {
            filters.orderStatus = EditorsCustomPhotoStatus.Delivered;
            this.setState({ forcedStatus: true });
        }

        if (
            this.state.forcedStatus === false &&
            filters.orderStatus === -1 &&
            selectedDate > today
        ) {
            filters.orderStatus = EditorsCustomPhotoStatus.Future;
            this.setState({ forcedStatus: true });
        }

        switch (filters.product) {
            case 0: {
                orders = orders.filter((x) => x.isExpress);
                break;
            }
            case 1: {
                orders = orders.filter((x) => x.isExpressWeekend);
                break;
            }
            case 2: {
                orders = orders.filter((x) => x.isVisualization);
                break;
            }
            default:
                break;
        }

        if (filters.orderStatus !== -1) {
            if (filters.orderStatus === EditorsCustomPhotoStatus.Delivered) {
                orders = orders.filter(
                    (x) =>
                        x.editorCustomPhotoStatus &&
                        (x.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Delivered ||
                            x.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Sent)
                );
            } else if (filters.orderStatus === EditorsCustomPhotoStatus.Sent) {
                orders = orders.filter(
                    (x) =>
                        x.editorCustomPhotoStatus &&
                        x.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Sent
                );
            } else if (filters.orderStatus === EditorsCustomPhotoStatus.Future) {
                orders = orders.filter(
                    (x) =>
                        x.editorCustomPhotoStatus &&
                        x.editorCustomPhotoStatus.value === EditorsCustomPhotoStatus.Future
                );
            } else {
                orders = orders.filter(
                    (x) =>
                        x.editorCustomPhotoStatus &&
                        x.editorCustomPhotoStatus.value.toString() ===
                            filters.orderStatus.toString()
                );
            }
        }

        if (
            filters.orderStatus !== EditorsCustomPhotoStatus.Delivered &&
            filters.orderStatus !== EditorsCustomPhotoStatus.Sent
        ) {
            orders = orders.filter(
                (x) =>
                    x.editorCustomPhotoStatus &&
                    x.editorCustomPhotoStatus.value !== EditorsCustomPhotoStatus.Delivered &&
                    x.editorCustomPhotoStatus.value !== EditorsCustomPhotoStatus.Sent
            );
        }

        const myOrders: any[] = orders.filter((order) => {
            return order.assignedToCurrentUser;
        });

        const allOrders: any[] = orders.filter((order) => {
            return !order.assignedToCurrentUser;
        });

        return (
            <div>
                {this.props.download.isRunning &&
                    (this.props.download.total > 0 ? (
                        <ProgressBarOverlay
                            active={this.props.download.isRunning}
                            filled={Math.floor(
                                (this.props.download.loaded / this.props.download.total) * 100
                            )}
                            extraText={this.props.download.speed}
                            fake={false}
                        />
                    ) : (
                        <ProgressBarOverlay
                            active={this.props.download.isRunning}
                            filled={0}
                            extraText={this.props.download.speed}
                            fake={true}
                        />
                    ))}
                <Row style={{ display: 'flex' }}>
                    <Col md={2} style={{ flexGrow: 1 }}>
                        <FormGroup className="no-margin">
                            <ControlLabel>
                                {Translate('orders/list/photo/header/date')}
                            </ControlLabel>
                            <DateTime
                                locale={moment.locale()}
                                timeFormat={false}
                                onChange={this.onDateTimeChange}
                                value={filters.endDate}
                                closeOnSelect={true}
                                isValidDate={(currentDate) => {
                                    // only allow today and future dates
                                    var today = moment().add(3, 'day');
                                    return currentDate.isBefore(today);
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2} style={{ flexGrow: 1 }}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('orders/list/photo/header/status')}
                            </ControlLabel>
                            <FormSelect
                                name="orderStatus"
                                value={this.state.filters.orderStatus}
                                onChange={this.formInputChangeHandler.onChange}
                            >
                                <option value="-1">
                                    {Translate('products/page/select-label/filter-all-active')}
                                </option>
                                {this.props.photoStatuses &&
                                    this.props.photoStatuses.map((t: any) => {
                                        return (
                                            <option key={t.value} value={t.value}>
                                                {Translate(t.displayName)}
                                            </option>
                                        );
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </Col>
                    <Col md={2} style={{ flexGrow: 1 }}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('orders/list/photo/header/image-product')}
                            </ControlLabel>
                            <FormSelect
                                name="product"
                                value={this.state.filters.product}
                                onChange={this.formInputChangeHandler.onChange}
                            >
                                <option value="-1">
                                    {Translate('products/page/select-label/filter')}
                                </option>
                                <option value="0">
                                    {Translate('orders/list/photo/header/only-express')}
                                </option>
                                <option value="1">
                                    {Translate('orders/list/photo/header/only-express-weekend')}
                                </option>
                                <option value="2">
                                    {Translate('orders/list/photo/header/only-visualization')}
                                </option>
                            </FormSelect>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Loader loaded={!this.state.isLoading}>
                        <h2>
                            {Translate('unedited-orders/header/my-orders')}{' '}
                            {!this.state.isLoading && (
                                <span className="number-of-orders">({myOrders.length})</span>
                            )}
                        </h2>
                        {this.createTable(myOrders)}
                        <h2>
                            {Translate('unedited-orders/header/all-orders')}{' '}
                            {!this.state.isLoading && (
                                <span className="number-of-orders">({allOrders.length})</span>
                            )}
                        </h2>
                        {this.createTable(allOrders)}
                    </Loader>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        orders: state.photoOrderLists.orders,
        photoStatuses: state.photoOrderLists.photoStatuses,
        user: getUser(state),
        download: state.download
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getUneditedPhotoOrders: (date: any) => dispatch(Actions.getUneditedPhotoOrders(date)),
            assignOrder: (
                orderId: number,
                userId: number,
                imageEditorName: string,
                assignedToCurrentUser: boolean
            ) =>
                dispatch(
                    Actions.assignOrder(orderId, userId, imageEditorName, assignedToCurrentUser)
                ),
            unAssignOrder: (orderId: number) => dispatch(Actions.unAssignOrder(orderId)),
            downloadFile: (url: string, data?: any) =>
                dispatch(DownloadActions.downloadFile(url, data))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UneditedPhotoOrdersList);
